import Admission from 'pages/UnionSide/Admission';
import Home from 'pages/CandidateSide/Home';
import StudentHome from 'pages/StudentSide/Home';
import Profile from 'pages/UnionSide/Profile';
import {Navigate, Route, useLocation, Routes, RoutesProps} from 'react-router-dom';
import Applications from 'pages/StudentSide/Applications/Applications';
import Timetable from 'pages/StudentSide/Timetable/Timetable';
import Commands from 'pages/StudentSide/Commands/Commands';
import DiplomaWork from 'pages/StudentSide/DiplomaWork';
import Exams from 'pages/StudentSide/Exams';

type userType = 'STUDENT' | 'CANDIDATE';

export function LoginRoute({isAuthenticated, children}: {isAuthenticated: boolean; children: JSX.Element}) {
	let location = useLocation();

	if (isAuthenticated) {
		return <Navigate to="/" state={{from: location}} replace />;
	}

	return children;
}

export function PrivateRoute({isAuthenticated, children}: {isAuthenticated: boolean; children: any}) {
	let location = useLocation();

	if (!isAuthenticated) {
		return <Navigate to="/login" state={{from: location}} replace />;
	}

	return children;
}

export function StatusRoute({statusID, children}: {statusID: number | null; children: any}) {
	let location = useLocation();

	if (!statusID) {
		return <Navigate to="/admission" state={{from: location}} replace />;
	}

	return children;
}

const AdmissionRoutes = ({isAuthenticated, regIsOpen}: {isAuthenticated: boolean; regIsOpen: boolean}) => {
	return (
		<Routes>
			<Route
				path="/"
				element={
					<PrivateRoute isAuthenticated={isAuthenticated}>
						<Home regIsOpen={regIsOpen} />
					</PrivateRoute>
				}
			/>
			<Route
				path="/admission"
				element={
					<PrivateRoute isAuthenticated={isAuthenticated}>
						<Admission role="CANDIDATE" />
					</PrivateRoute>
				}
			/>
			<Route
				path="/profile"
				element={
					<PrivateRoute isAuthenticated={isAuthenticated}>
						<Profile />
					</PrivateRoute>
				}
			/>
			<Route path="*" element={<Navigate to="/" />} />
		</Routes>
	);
};

const StudentRoutes = ({isAuthenticated}: {isAuthenticated: boolean}) => {
	return (
		<Routes>
			<Route path="/" element={<StudentHome />} />
			<Route
				path="/admission"
				element={
					<PrivateRoute isAuthenticated={isAuthenticated}>
						<Admission role="STUDENT" />
					</PrivateRoute>
				}
			/>
			<Route
				path="/exams"
				element={
					<PrivateRoute isAuthenticated={isAuthenticated}>
						<Exams />
					</PrivateRoute>
				}
			/>
			<Route
				path="/timetable"
				element={
					<PrivateRoute isAuthenticated={isAuthenticated}>
						<Timetable />
					</PrivateRoute>
				}
			/>
			<Route
				path="/applications"
				element={
					<PrivateRoute isAuthenticated={isAuthenticated}>
						<Applications />
					</PrivateRoute>
				}
			/>
			<Route
				path="/commands"
				element={
					<PrivateRoute isAuthenticated={isAuthenticated}>
						<Commands />
					</PrivateRoute>
				}
			/>
			<Route
				path="/diplomaWork"
				element={
					<PrivateRoute isAuthenticated={isAuthenticated}>
						<DiplomaWork />
					</PrivateRoute>
				}
			/>
			<Route
				path="/profile"
				element={
					<PrivateRoute isAuthenticated={isAuthenticated}>
						<Profile />
					</PrivateRoute>
				}
			/>
			<Route path="*" element={<Navigate to="/" />} />
		</Routes>
	);
};

interface IAppRoutesProps extends RoutesProps {
	role: userType;
	isAuthenticated: boolean;
	regIsOpen: boolean;
}

export const AppRoutes = ({role, isAuthenticated, children, regIsOpen}: IAppRoutesProps) => {
	if (!isAuthenticated) return <Routes>{children}</Routes>;

	return (
		<Routes>
			{role === 'CANDIDATE' ? (
				<Route
					path="*"
					element={<AdmissionRoutes regIsOpen={regIsOpen} isAuthenticated={isAuthenticated} />}
				/>
			) : (
				<Route path="*" element={<StudentRoutes isAuthenticated={isAuthenticated} />} />
			)}
			{children}
		</Routes>
	);
};
